export default String.raw`
.cart-container {
    width: 100%;
    min-height: inherit;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: $primaryColorFont;
    display: flex;
    flex-direction: column;
    .cart {
        flex-grow: 1;
        padding: 16px 130px;
        &.thank-you-content {
            padding: 64px 130px;
        }
        &__empty {
            width: fit-content;
            margin: 64px auto 32px;
            display: flex;
            flex-direction: column;
            align-items: center;
            &-wrapper {
                display: flex;
                align-items: center;
            }
            &-icon {
                width: 52px;
                height: 52px;
                margin-right: 24px;
            }
            &-text {
                font-size: 24px;
                font-weight: 500;
                line-height: 32px;
            }
            &-btn {
                width: fit-content;
                margin-top: 24px;
                display: flex;
                align-items: center;
                svg {
                    width: 24px;
                    height: 24px;
                    margin-left: 8px;
                    fill: #FFF;
                }
                &:hover svg {
                    fill: $btnSolidTextColor;
                }
            }
        }
        &__info-bar {
            width: 100%;
            padding: 8px 32px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 8px;
            margin-bottom: 16px;
            svg {
                width: 24px;
                height: 24px;
                margin-right: 8px;
            }
            &.warning-bar {
                background-color: #FFF2DA;
                svg {
                    fill: #F5A623;
                }
            }
            &.success-bar {
                background-color: #E5FFED;
                svg {
                    fill: #008945;
                }
            }
        }
        &__action-btn {
            width: fit-content;
            display: flex;
            align-items: center;
            font-family: $fontFamily, sans-serif;
            font-size: 14px;
            font-weight: 600;
            line-height: 20px;
            color: $btnSolidBgColor;
            background: transparent;
            border: none;
            padding: 0;
            cursor: pointer;
            svg {
                fill: $btnSolidBgColor;
                width: 24px;
                height: 24px;
                margin-right: 4px;
            }
            &:hover {
                color: $hoverOverButton;
                svg {
                    fill: $hoverOverButton;
                }
            }
            &:disabled {
                color: #D5D5D5;
                cursor: default;
                svg {
                    fill: #D5D5D5;
                }
            }
        }
        &__header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 32px;
            &-wrapper {
                display: flex;
                align-items: center;
            }
            &-buttons {
                .cart__action-btn {
                    margin-right: 24px;
                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
            &-title {
                font-size: 24px;
                font-weight: 500;
                line-height: 32px;
            }
        }
        &__products {
            &-footer .pagination {
                justify-content: center;
                margin: 16px 0 0;
            }
            &-expanded {
                border-bottom: 1px solid $lighterColor;
            }
        }
        &__options {
            display: grid;
            justify-content: space-between;
            margin: 32px 0;
            &.first-step {
                grid-template-columns: 40% 40%;
                grid-template-rows: repeat(2, auto);
            }
            &.third-step {
                grid-template-columns: 55% 40%;
            }
            &.inquiry-step {
                grid-template-columns: 100%;
                justify-content: center;
            }
        }
        &__summary {
            grid-column: 2;
            grid-row: 1;
            &-row {
                display: flex;
                justify-content: space-between;
                padding-bottom: 8px;
                &.strong {
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 24px;
                }
                &.pt {
                    padding-top: 8px;
                }
                &.pb {
                    padding-bottom: 8px;
                }
            }
        }
        &__loyalty-summary {
            display: flex;
            gap: 8px;
            padding-bottom: 16px;

            svg {
                width: 24px;
                height: 24px;
            }
        }
        &__loyalty-info {
            display: flex;
            max-width: 450px;
            padding: 20px 32px;
            flex-direction: row;
            align-items: flex-start;
            gap: 16px;
            align-self: stretch;
            border-radius: 12px;
            background: $activeListIconBackgroundColor;
            height: fit-content;

            svg {
                width: 48px;
                height: 48px;
                fill: $primaryColorFont;
                flex-shrink: 0;
            }

            span {
                display: flex;
                gap: 4px;
                align-self: stretch;
                justify-content: flex-start;
                flex-direction: column;
                align-items: flex-start;

                &:has(> p:only-child) {
                    justify-content: center;
                }
            }
        }

        &__points {
            margin-top: 8px;
        }

        &__pay-with-points {
            display: flex;
            margin: 8px 0 16px 24px;
            gap: 8px;
            align-items: flex-start;
            justify-content: space-between;

            &--content {
                display: flex;
                flex-direction: column;
                gap: 4px;
                font-size: 12px;
            }
        }
        &__back-btn {
            grid-row: 2;
            grid-column: 1;
            height: fit-content;
            align-self: flex-end;
        }
        &__next-btn {
            grid-row: 2;
            grid-column: 2;
            margin: 32px auto 0;
            width: 100%;
            max-width: 280px;
        }
        &__second-step {
            height: fit-content;
            padding-top: 16px;
            display: flex;
            justify-content: center;
    
            .login-container {
                margin: 0;
                min-height: 100%;
                margin-right: 64px;
                border: 1px solid #D5D5D5;
                box-shadow: none;
                width: 444px;
            }
        }
        &__tooltip {
            position: relative;
            width: fit-content;
            &-icon {
                width: 24px;
                height: 24px;
                fill: $primaryColor;
                padding: 4px;
            }
            &-info {
                width: 205px;
                position: absolute;
                top: 25px;
                left: 0;
                padding: 4px 8px;
                background: $secondaryColorFont;
                color: #FFF;
                font-size: 12px;
                line-height: 16px;
                border-radius: 3px;
            }
        }
        &__redirect {
            display: flex;
            flex-direction: column;
            align-items: center;
            &-title {
                font-size: 24px;
                font-weight: 500;
                line-height: 32px;
                margin-bottom: 32px;
            }
            &-form {
                max-width: 700px;
                width: 100%;
                padding: 32px;
                background-color: #F8F9FA;
                border-radius: 12px;
            }
            &-wrapper {
                display: flex;
                align-items: center;
            }
            &-icon {
                width: 48px;
                height: 48px;
                fill: $secondaryColorFont;
                margin-right: 16px;
            }
            &-text {
                margin-bottom: 4px;
                span {
                    font-weight: 600;
                }
            }
            &-info {
                margin: 16px 0;
            }
            &-btn {
                width: fit-content;
                padding: 8px 20px;
                margin: 0 auto;
                align-self: center;
                display: flex;
                align-items: center;
                svg {
                    width: 24px;
                    height: 24px;
                    &.right-icon {
                        margin-left: 8px;
                    }
                }
                &:hover svg {
                    fill: $btnSolidTextColor;
                }
            }
        }
        &__radio {
            display: none;
            &:checked {
                & ~ .cart__radio-box {
                    border-color: $primaryColor;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    &::after {
                        content: "";
                        display: block;
                        width: 8px;
                        height: 8px;
                        border-radius: 50%;
                        background: $primaryColor;
                    }
                }
            }
            &-box {
                display: block;
                width: 16px;
                height: 16px;
                border: 1px solid #767676;
                border-radius: 50%;
                cursor: pointer;
            }
        }
        &__check {
            &-label {
                display: flex;
                flex-wrap: wrap;
                width: fit-content;
                cursor: pointer;
                input[type=checkbox] {
                    display: none;
                    &:checked ~ .cart__check-checkbox {
                        background: $primaryColor;
                        svg {
                            display: block;
                        }
                    }
                    &.validation-error-js ~ .cart__check-checkbox {
                        border-color: #DA2442;
                    }
                }
            }
            &-checkbox {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 16px;
                height: 16px;
                border-radius: 4px;
                border: 1px solid #767676;
                svg {
                    display: none;
                    width: 12px;
                    height: 12px;
                    fill: #FFF;
                }
            }
            &-text {
                margin-left: 8px;
            }
        }
        &__save-btn {
            display: block;
            width: 100%;
            max-width: 300px;
            margin: auto;
        }
        &__order-button {
            width: 100%;
            &:disabled {
                background: #D5D5D5;
                color: #FFF;
                cursor: default;
            }
        }
        &__select {
            position: relative;
            cursor: pointer;
            &-value {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            &-arrow {
                width: 24px;
                height: 24px;
                padding: 3px;
                transform: rotate(0);
                transition: 0.3s all;
                svg {
                    width: 100%;
                    height: 100%;
                    fill: $primaryColorFont;
                }
                &.rotate {
                    transform: rotate(180deg);
                }
            }
            &-list {
                width: 100%;
                position: absolute;
                left: 0;
                // temp z-index
                z-index: 1000;
                background: $bgColor;
                border-radius: 5px;
                box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.5);
                overflow-y: auto;
                &::-webkit-scrollbar {
                    width: 4px;
                    border-radius: 50%;
                }
                &::-webkit-scrollbar-track {
                    -webkit-box-shadow: inset 0 0 4px transparent;
                }
                &::-webkit-scrollbar-thumb {
                    background-color: rgba(#959595, 0.5);
                    outline: none;
                    border-radius: 2px;
                    &:hover{
                        background-color: #959595;
                    }
                }
            }
            &-item {
                min-height: 40px;
                padding: 10px 16px;
                margin: 0;
                color: $primaryColorFont;
                border: none;
                cursor: pointer;
                transition: all ease 300ms;
                &:hover, &.focused-option-js {
                    color: $hoverOverButton;
                    background: #F1DDDE;
                }
            }
        }
        &__tos {
            &-consent {
                margin-bottom: 8px;
                &:last-of-type {
                    margin-bottom: 16px;
                }
                &-label {
                    margin-left: 8px;
                    width: calc(100% - 24px);
                    cursor: pointer;
                }
            }
            &-label {
                display: flex;
                flex-wrap: wrap;
                input[type=checkbox] {
                    display: none;
                    &:checked ~ .cart__tos-checkbox {
                        background: $primaryColor;
                        svg {
                            display: block;
                        }
                    }
                    &.validation-error-js ~ .cart__tos-checkbox {
                        border-color: #DA2442;
                    }
                }
            }
            &-checkbox {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 16px;
                height: 16px;
                border-radius: 4px;
                border: 1px solid #767676;
                svg {
                    display: none;
                    width: 12px;
                    height: 12px;
                    fill: #FFF;
                }
            }
            &-required {
                color: #DA2442;
            }
            &-error {
                width: 100%;
                color: #DA2442;
                margin: 4px 0;
                font-size: 12px;
            }
        }
        &__coupon {
            margin: 16px 0;
            &-wrapper {
                display: flex;
            }
            &-content {
                margin-top: 16px;
            }
            &-btn {
                background: #FFF;
                color: $primaryColor;
                border: 2px solid $primaryColor;
                margin-left: 16px;
            }
        }
        &__inquiry {
            grid-row: 1;
            grid-column: 1;
            width: 100%;
            max-width: 638px;
            margin: auto;
            .cart-data-section {
                padding-top: 16px;
                border-bottom: none;
                &__content {
                    padding-bottom: 0;
                }
            }
            &-wrapper {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                margin-top: 16px;
            }
            .cart__consents {
                display: flex;
                flex-direction: column;
            }
            &-btn {
                align-self: center;
                width: 100%;
                max-width: 320px;
            }
        }
    }
}

.cart__popup {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(46, 46, 46, 0.20);
    &-box {
        background: $bgColor;
        border-radius: 12px;
        padding: 30px;
        &.recalculate {
            width: 500px;
        }
        &.cart-customer-address {
            width: 100%;
            max-width: 700px;
        }
        &.maps {
            width: 100%;
            max-width: 870px;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
        }
        &.channels {
            width: fit-content;
            max-width: 696px;
        }
    }
    &-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
    }
    &-title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
        padding-right: 16px;
        width: 100%;
        &--with-button{
            @extend .cart__popup-title;
            justify-content: space-between;
            padding: 0;

            .close-button {
                svg {
                    width: 24px;
                    height: 24px;
                    margin: 0;
                    padding: 0;
                }
            }
        }
        svg {
            width: 32px;
            height: 32px;
            margin-right: 16px;
            &.warning-icon {
                fill: $warnColor;
            }
        }
    }
    &-closer {
        fill: $labelsColor;
        cursor: pointer;
        width: 24px;
        height: 24px;

        &:hover {
            fill: $hoverOverButton;
        }
    }
    &-content {
        display: flex;
        flex-direction: column;
    }
    &-recalculate {
        width: fit-content;
        padding: 8px 20px;
        margin-top: 32px;
        align-self: center;
        display: flex;
        align-items: center;
        svg {
            fill: #FFF;
            width: 24px;
            height: 24px;
            &.right-icon {
                margin-left: 8px;
            }
        }
        &:hover svg {
            fill: $btnSolidTextColor;
        }
    }
    &-list {
        list-style-type: disc;
        padding: 5px 0 0 30px;
    }
    .form__invalid-input {
        margin-top: 2px;
    }
}

.cart-header {
    width: 100%;
    display: grid;
    grid-template-columns: 15% auto 15%;
    padding: 16px 130px;
    border-bottom: 1px solid #E7E7E7;
    &__logo {
        grid-column: 1;
        margin-right: 32px;
        display: flex;
        align-items: center;
        a {
            display: block;
        }
        img {
            height: auto;
            width: auto;
            max-width: 130px;
            max-height: 40px;
            background: $bgColorLogo;
        }
    }
    &__steps {
        grid-column: 2;
        display: flex;
        align-items: center;
        justify-content: center;
        &-separator {
            display: block;
            width: 100%;
            max-width: 124px;
            height: 1px;
            background: #D5D5D5;
            margin: 0 16px 20px;
        }
    }
    &__step {
        display: flex;
        flex-direction: column;
        align-items: center;
        background: transparent;
        border: none;
        cursor: pointer;
        &-icon {
            width: 32px;
            height: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 6px;
            border-radius: 50%;
            background: $primaryColor;
            color: $bgColor;
            font-size: 18px;
            svg {
                width: 24px;
                height: 24px;
                fill: $bgColor;
            }
            &:hover {
                background: $hoverOverButton;
            }
        }
        &-text {
            font-size: 12px;
            font-weight: 500;
            line-height: 16px;
            margin-top: 4px;
        }
        &.disable {
            cursor: default;
            .cart-header__step {
                &-icon {
                    background: #959595;
                    &:hover {
                        background: #959595;
                    }
                }
                &-text {
                    color: #959595;
                }
            }
        }
    }
}

.cart-footer {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 16px 130px 32px;
    font-size: 10px;
    line-height: 16px;
    color: $secondaryColorFont;
    p {
        font-size: 10px;
        line-height: 16px;
    }
    a {
        color: $secondaryColorFont; 
    }
}

.cart-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 10px 16px;
    border-bottom: 1px solid #E7E7E7;
    &__number {
        width: 3%;
        word-break: break-word;
        padding-right: 16px;
    }
    &__product {
        width: 27%;
        &-wrapper {
            display: flex;
            align-items: flex-start;
        }
        &-image {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 40px;
            height: 40px;
            margin-right: 16px;
            img {
                border-radius: 2px;
                max-width: 40px;
                max-height: 40px;
            }
        }
        &-name {
            display: inline-block;
            color: $primaryColor;
            margin-bottom: 4px;
        }
        &-info {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: wrap;
            font-size: 12px;
            line-height: 16px;
            li {
                display: flex;
                flex-wrap: nowrap;
                &:not(:last-child)::after {
                    content: "";
                    display: block;
                    width: 1px;
                    height: 16px;
                    background-color: #E8E8E8;
                    margin: 0 8px;
                }
            }
            .loyalty-info {
                display: none;
            }
            &.primary-color {
                color: $primaryColor;
                font-weight: 600;
            }
        }
    }
    &:not(:has(.cart-row__price)) {
        .cart-row__product {
            width: 51%;
        }
    }
    &:not(:has(.cart-row__deposit-price)) {
        .cart-row__product {
            width: 39%;
        }
    }
    &__price {
        width: 12%;
        text-align: right;
        padding-right: 24px;
        &-unit {
            margin-top: 2px;
            font-size: 12px;
            line-height: 16px;
        }
    }
    &__total {
        &-price {
            width: 12%;
            text-align: right;
            padding-right: 24px;
        }
        &-unit {
            margin-top: 2px;
            font-size: 12px;
            line-height: 16px;
        }
    }
    &__deposit-price {
        width: 12%;
        text-align: right;
        padding-right: 24px;

        .deposit {
            &__unit {
                margin-top: 2px;
                font-size: 12px;
                line-height: 16px;
            }
        }
    }
    &__quantity {
        width: 11%;
        &-amount {
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            &:has(.cart-amount-stepper-validation__error:not(.hidden-js)) {
                .cart-amount-stepper, .cart-amount-stepper-unit {
                    display: none;
                }
                .cart-amount-stepper-validation {
                    height: 42px;
                    &.higher {
                        height: 58px;
                    }
                }
            }
        }
        &-info {
            font-size: 12px;
            line-height: 16px;
        }
    }
    &__value {
        width: 12%;
        text-align: right;
        padding-right: 24px;
    }
    &__currency {
        width: 4%;
    }
    &__options {
        width: 7%;
        text-align: right;
        position: relative;
        display: flex;
        justify-content: flex-end;
        &-deleter {
            margin-left: auto;
        }
        &-btn {
            background: transparent;
            border: none;
            padding: 0;
            transform: rotate(0);
            transition: transform 0.5s linear;
            &.chevron {
                margin-left: 10px;
                svg {
                    padding: 4px;
                }
            }
            svg {
                fill: $btnSolidBgColor;
                width: 24px;
                height: 24px;
                cursor: pointer;
                &:hover {
                    fill: $hoverOverButton;
                }
            }
            &.expanded-js {
                transform: rotate(180deg);
            }
        }
    }
    &__more-btn {
        background: transparent;
        border: none;
        padding: 0;
        width: 32px;
        height: 32px;        
        border-radius: 50%;
        margin-left: auto;
        &:hover {
            background: rgba(147, 67, 70, 0.1);
        }
        svg {
            width: 24px;
            height: 24px;
            fill: $primaryColor;
            cursor: pointer;
        }
    }
    &__more-list {
        position: absolute;
        top: 32px;
        right: 0;
        z-index: 1;
        width: max-content;
        background-color: $bgColor;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
        border-radius: 5px;
        text-align: left;
        li {
            padding: 10px 16px;
            cursor: pointer;
            &:hover, &.focused-option-js {
                background-color: rgba(147, 67, 70, 0.1);
                color: $primaryColor;
            }
        }
    }
    &.header-row {
        font-weight: 500;
    }
    &__expandable {
        width: 100%;
        background: #F8F9FA;
    }
    &__additional-info {
        padding: 8px 16px 16px 62px;
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
    }
}

.cart-amount-stepper {
    width: fit-content;
    display: flex;
    align-items: center;
    background: $inputsBgColor;
    border: 1px solid #767676;
    border-radius: 5px;
    &__minus, &__plus {
        background: transparent;
        border: none;
        padding: 6px;
        cursor: pointer;
        svg {
            width: 16px;
            height: 16px;
            fill: #959595;
        }
    }
    input {
        width: 42px;
        border-color: transparent;
        background: transparent;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: $primaryColorFont;
    }
    &-unit {
        margin-left: 4px;
    }
    &-validation {
        width: 100%;
        margin-top: 4px;
        div {
            font-size: 12px;
            line-height: 16px;
        }
        &__error {
            color: #DA2442;
        }
    }
}

.cart-additional-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-right: 100px;
    &__title {
        font-weight: 700;
        margin-bottom: 2px;
    }
    &__content {
        font-size: 12px;
        line-height: 16px;
    }
}

.cart-account-box {
    max-width: 444px;
    border-radius: 12px;
    border: 1px solid #D5D5D5;
    background: $bgColor;
    &__section {
        &:first-child {
            padding: 32px 32px 0;
        }
        &:last-child {
            padding: 0 32px 32px;
        }
        &:only-child {
            padding: 32px;
        }
    }
    &__title {
        font-size: 24px;
        font-weight: 500;
        line-height: 32px;
    }
    &__text {
        margin: 24px 0;
    }
    &__list {
        li {
            display: flex;
            align-items: center;
            margin: 10px 0;
            svg {
                width: 24px;
                height: 24px;
                fill: #008945;
                margin-right: 8px;
            }
        }
    }
    &__divider {
        display: block;
        height: 1px;
        width: calc(100% - 16px);
        background: #D5D5D5;
        margin: 24px auto;
    }
    &__btn {
        display: block;
        width: 100%;
        margin-top: 24px;
        &.secondary-btn {
            margin-top: 0;
            color: $btnSolidBgColor;
            background-color: $btnSolidTextColor;
            border: 2px solid $btnSolidBgColor;
            &:hover {
                color: $hoverOverButton;
                background-color: $btnSolidTextColor;
                border: 2px solid $hoverOverButton;
            }
        }
    }
}

.cart-data-section {
    width: 100%;
    padding-top: 24px;
    border-bottom: 1px solid #D5D5D5;
    &:first-child {
        padding-top: 0;
    }
    &.last {
        border-bottom: none;
    }
    &__header {
        padding-bottom: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.hide-content {
            padding-bottom: 0;
        }
        &-title {
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            font-size: 18px;
            font-weight: 600;
            line-height: 24px;
        }
        &-small {
            width: 100%;
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            color: $secondaryColorFont;
            margin-top: 8px;
        }
        &-icon {
            margin-left: 8px;
        }
        &-btn {
            margin-left: 8px;
        }
    }
    &__content {
        padding-bottom: 24px;
    }
}

.cart-address-form {
    &__item {
        margin-bottom: 24px;

        &-title {
            margin-bottom: 12px;
        }
        &-wrapper {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            & > div, & > label {
                margin-right: 16px;
            }
        }
    }
    &__label {
        display: flex;
        align-items: center;
        cursor: pointer;
    }
    &__radio {
        margin-right: 8px;
    }
    &__additional-text {
        margin-bottom: 12px;
    }
    &__check {
        margin-bottom: 24px;
    }
    &__btn-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        &.customer-address-form {
            justify-content: flex-end;
            .cart__save-btn {
                width: fit-content;
                max-width: none;
                margin: unset;
                margin-left: 24px;
            }
        }
    }
}

.cart-address-presentation {
    width: 100%;
    font-size: 12px;
    line-height: 16px;
    &__text {
        display: flex;
        margin-bottom: 4px;
        &:last-child {
            margin-bottom: 0;
        }
        & div:last-child {
            font-weight: 600;
            margin-left: 4px;
        }
        &.column {
            flex-direction: column;
            & div:last-child {
                margin-left: 0;
            }
        }
    }
    &__title {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        margin: 24px 0 8px;
        &-icon {
            width: 20px;
            height: 20px;
            fill: #008945;
            padding: 3px;
            margin-right: 8px;
        }
    }
}

.cart-addresses-list {
    max-height: 500px;
    overflow-y: auto;
    margin-bottom: 5px;
    &::-webkit-scrollbar {
        width: 4px;
        border-radius: 50%;
    }
    &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 4px transparent;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(#959595, 0.5);
        outline: none;
        border-radius: 2px;
        &:hover{
            background-color: #959595;
        }
    }
    &__item {
        background: $bgColor;
        border-radius: 6px;
        display: flex;
        padding: 16px;
        margin-bottom: 24px;
        font-size: 12px;
        line-height: 16px;
        border: 2px solid #D5D5D5;
        &:hover {
            background: #F1DDDE;
            border-color: #F1DDDE;
        }
        &-label {
            width: 100%;
            display: flex;
            align-items: center;
            cursor: pointer;
        }
        &:has(input[type=radio]:checked.cart__radio) {
            border-color: $primaryColor;
        }
        &-radio {
            margin-right: 16px;
        }
        &-columns {
            display: flex;
            justify-content: space-between;
        }
        &-title {
            font-weight: 600;
            margin-bottom: 8px;
        }
        &-text {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 4px;
            & > div {
                max-width: 152px;
                width: 100vw;
                &:first-child {
                    margin-right: 80px;
                }
            }
        }
        &-edit {
            white-space: nowrap;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-end;
        }
        &-default {
            width: fit-content;
            border-radius: 2px;
            background: #41682C;
            color: #FFFFFF;
            font-weight: 500;
            padding: 1px 8px;
        }
    }
}

.cart-delivery-item {
    display: flex;
    padding: 12px 0;
    cursor: pointer;
    &__radio {
        padding: 4px;
        margin-right: 8px;
    }
    &__wrapper {
        width: 100%;
        display: grid;
        grid-template-columns: 70% 30%;
        grid-template-rows: repeat(2, auto);
        justify-content: space-between;
        .cart-choosePaymentChannel{
            grid-column: 1;
            grid-row: 2;
        }
    }
    &__name {
        grid-column: 1;
        grid-row: 1;
        display: flex;
        align-items: center;
        img {
            height: auto;
            width: auto;
            max-height: 24px;
            max-width: 60px;
            margin-right: 8px;
        }
    }
    &__price {
        grid-column: 2;
        grid-row: 1;
        text-align: right;
        &-free {
            grid-column: 2;
            text-align: right;
            font-size: 14px;
            color: $primaryColor;
        }
        &-text {
            grid-column: 2;
            grid-row: 1;
            display: flex;
            justify-content: flex-end;
            .cart__tooltip-info {
                text-align: left;
                z-index: 2;
            }
        }
    }
    &__date {
        margin-top: 18px;
        margin-left: auto;
        width: 270px;
        grid-column: 1 / 3;
        grid-row: 2;
        &.info {
            width: fit-content;
            color: #767676;
            font-size: 12px;
            line-height: 16px;
            text-align: right;
        }
    }
    &__collection-points {
        margin-top: 18px;
        grid-column: 1;
        grid-row: 2;
    }
    &__payment-channel {
        grid-column: 1;
        grid-row: 2;
        img {
            margin: 12px 0;
            height: auto;
            width: auto;
            max-height: 30px;
            max-width: 66px;
        }
    }
}

.cart-collection-point {
    &__content {
        margin-top: 8px;
        &-item {
            margin-bottom: 4px;
            display: flex;
            align-items: center;
            cursor: pointer;
            &:hover {
                color: $primaryColor;
            }
            &::before {
                content: "";
                display: block;
                width: 12px;
                height: 12px;
                background-color: #DDD;
                border-radius: 50%;
                margin-right: 4px;
            }
        }
    }
    &__btn {
        margin-top: 10px;
    }
}

.cart-payment-channel {
    padding: 10px 36px 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    height: 550px;
    overflow: auto;
    &__item {
        display: flex;
        flex-direction: column;
        margin: 0 8px 16px;
        cursor: pointer;
        &-img {
            width: 96px;
            height: 54px;
            padding: 8px;
            margin-bottom: 8px;
            display: flex;
            justify-content: center;
            img {
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
            }
        }
        &-name {
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            text-align: center;
            max-width: 96px;
        }
        input {
            display: none;
        }
    }
}

.cart-message {
    position: relative;
    margin-bottom: 0;
    &__note {
        width: 100%;
        border-radius: 5px;
        border: 1px solid $secondaryColorFont;
        font-size: 14px;
        padding: 8px 16px;
        height: auto;
        min-height: unset;
        max-height: unset;
        &.on-inquiry {
            min-height: 112px;
        }
        &-counter {
            position: absolute;
            bottom: 6px;
            right: 25px;
        }
    }
    .form__input-info.on-inquiry {
        top: 20%;
    }
    &__attachements {
        display: flex;
        flex-wrap: wrap;
        margin-top: 8px;
        &-item {
            display: flex;
            align-items: center;
            color: $primaryColor;
            font-weight: 600;
            margin-right: 16px;
        }
        &-icon {
            fill: $primaryColor;
            width: 24px;
            height: 24px;
            padding: 3px;
            margin-right: 4px;
        }
        &-closer {
            fill: #DA2442;
            width: 14px;
            height: 14px;
            margin-left: 4px;
            cursor: pointer;
        }
    }
    &__add-file {
        display: flex;
        align-items: center;
        color: $primaryColor;
        margin: 16px 0;
        font-weight: 600;
        cursor: pointer;
        svg {
            fill: $primaryColor;
            width: 24px;
            height: 24px;
            padding: 3px;
        }
    }
}

.thank-you {
    &__title {
        display: flex;
        align-items: center;
        font-size: 24px;
        font-weight: 500;
        line-height: 32px;
        margin-bottom: 24px;
        svg {
            width: 32px;
            height: 32px;
            fill: #DA2442;
            margin-right: 16px;
        }
    }
    &__text {
        margin-bottom: 32px;
        span {
            font-weight: 700;
        }
    }
    &__box {
        display: flex;
        align-items: flex-start;
        width: fit-content;
        padding: 24px 48px;
        background: #F8F9FA;
        border-radius: 8px;
        &-column {
            width: 100%;
            max-width: 370px;
            &:first-child {
                margin-right: 42px;
            }

            .cart {
                &__loyalty-info {
                    background: none;
                    padding: 0;
                    width: max-content;
                }
            }
        }
        &-text {
           margin-bottom: 4px;
           span {
            font-weight: 600;
           } 
        }
        &-btn {
            display: flex;
            justify-content: center;
            max-width: 300px;
            margin-top: 16px;
            svg {
                width: 24px;
                height: 24px;
                &.right-icon {
                    margin-left: 8px;
                }
            }
            &:hover svg {
                fill: $btnSolidTextColor;
            }
            &.message {
                color: $primaryColor;
            }
        }
    }

    &__column-wrapper {
        display: flex;
        flex-wrap: wrap;
        margin: 32px 0;
    }

    &__column {
        width: 100%;
        max-width: 277px;
        margin-right: 24px;
        &-title {
            font-size: 16px;
            font-weight: 600;
            line-height: 20px;
            margin-bottom: 16px;
        }
        &-text {
            font-size: 12px;
            line-height: 16px;
            margin-bottom: 4px;
            span {
                font-weight: 600;
            }
        }
    }

    &__section {
        margin-bottom: 40px;
        &-title {
            font-size: 16px;
            font-weight: 600;
            line-height: 20px;
            margin-bottom: 24px;
        }
        &-wrapper {
            display: flex;
            align-items: center;
        }
        &-text {
            margin-bottom: 4px;
            font-size: 12px;
            line-height: 16px;
            &.bold {
                font-size: 14px;
                font-weight: 500;
            }
        }
    }

    &__divider {
        width: 100%;
        height: 1px;
        background: #E7E7E7;
    }
}

.cart-hide-on-desktop {
    display: none;
}

.cart-recommendations {
    position: relative;
    padding: 32px 0;
    &__title {
        font-size: 24px;
        font-weight: 500;
        line-height: 32px;
        color: $primaryColorFont;
        margin-bottom: 24px;
        padding: 0 130px;
    }
    &::after, &::before {
        content: "";
        display: block;
        width: 130px;
        position: absolute;
        top: 0;
        bottom: 0;
        z-index: 2;
    }
    &::after {
        right: 0;
        background: linear-gradient(270deg, rgba(255, 255, 255, 0.80) 0%, rgba(255, 255, 255, 0.00) 100%);
    }
    &::before {
        left: 0;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0.80) 0%, rgba(255, 255, 255, 0.00) 100%);
    }
    
    .ai-generated-content {
        text-align: center;
    }
}

.cart-recommendations-item {
    display: flex !important;
    justify-content: center;
    width: calc(100% / 4.5);
    &__wrapper {
        height: 460px;
        max-width: 270px;
        width: 100%;
    }
    &__image-wrapper {
        position: relative;
        max-width: 270px;
        max-height: 270px;
        width: 270px;
        height: 270px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
            border-radius: 4px;
        }
    }
    &__flags {
        position: absolute;
        top: 8px;
        left: -4px;
    }
    &__flag {
       width: fit-content;
       font-size: 10px;
       font-weight: 500;
       line-height: 15px;
       padding: 2px 8px;
       margin-bottom: 2px;
       border-radius: 2px;
       color: $lightestColorFont;
       &.quantity-flag {
        background: $primaryColor;
        color: $lightestColorFont;
       }
    }
    &__section {
        margin: 16px 0;
        &.btn-section {
            display: flex;
            align-items: center;
        }
    }
    &__name {
        height: 40px;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: $primaryColorFont;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }
    &__price-wrapper {
        display: flex;
        align-items: baseline;
    }
    &__price {
        margin-right: 8px;
        &.bold-price {
            font-weight: 600;
        }
        &.old-price {
            font-size: 12px;
            line-height: 18px;
            text-decoration: line-through;
            display: flex;
            align-items: center;
            svg {
                width: 12px;
                height: 12px;
                text-decoration: none;
                margin-left: 4px;
            }
        }
    }
    &__omnibus {
        margin-top: 8px;
        font-size: 12px;
        line-height: 16px;
        color: #767676;
    }
    &__omnibus-placeholder{
        min-height: 16px;
        margin-top: 8px;
    }
    &__primary-btn {
        display: flex;
        align-items: center;
        width: 100%;
        svg {
            width: 24px;
            height: 24px;
        }
        &:hover svg {
            fill: $btnSolidTextColor;
        }
    }
    &__slider-prev, &__slider-next {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 48px;
        height: 48px;
        background-color: #FFFFFF;
        border-radius: 4px;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
        position: absolute;
        z-index: 1;
        top: calc(50% - 48px);
        cursor: pointer;
        svg {
            width: 16px;
            height: 16px;
            fill: $primaryColor;
        }
    }
    &__slider-prev {
        left: 135px;
    }
    &__slider-next {
        right: 135px;
    }
}

.product-item__coupons {
    margin: 8px 0;

    .show-more-coupons-cart {
        @include body-1-regular;
        text-decoration: underline;
    }
}
`